import { createContext, useContext } from "react";
import type { User } from "firebase/auth";

/**
 * Auth context object + hook, kept free of any Firebase *runtime* import (the
 * `User` import is type-only and erased at build). This lets the static landing
 * prerender (src/entry-prerender.tsx) supply a logged-out value without pulling
 * Firebase into the SSR bundle. The real provider lives in ./AuthContext.tsx.
 */
export interface AuthContextValue {
  user: User | null;
  loading: boolean;
}

export const AuthContext = createContext<AuthContextValue>({
  user: null,
  loading: true,
});

export function useAuth(): AuthContextValue {
  return useContext(AuthContext);
}
